import { Network, Cctv, Monitor, Printer, Building2, FolderKanban } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, CtaBand, SectionHead } from "@/components/blocks";
import { Reveal } from "@/components/Reveal";
import { COMPANY, WA_MESSAGES } from "@/data/site";
import { breadcrumbJsonLd } from "@/lib/seo";

const CATEGORIES = [
  { icon: Network, label: "Networking" },
  { icon: Cctv, label: "CCTV" },
  { icon: Monitor, label: "PC Installation" },
  { icon: Printer, label: "Printer Installation" },
  { icon: Building2, label: "Installation & Configuration" },
];

export default function Projects() {
  return (
    <>
      <Seo
        title="Projects | Cherians Tech Solutions, Mallappally"
        siteName={COMPANY.brand}
        description="Real installations. Real requirements. Practical technology solutions — project case studies from Cherians Tech Solutions, Mallappally."
        jsonLd={breadcrumbJsonLd([{ label: "Projects" }])}
      />
      <PageHero
        eyebrow="OUR WORK"
        title="Projects"
        intro="Real installations. Real requirements. Practical technology solutions."
        crumbs={[{ label: "Projects" }]}
      />
      <section className="section-pad bg-white">
        <div className="container-site max-w-3xl">
          <SectionHead
            title="Case Studies Are Being Documented"
            text="We only publish real CTS projects — with the customer's permission and genuine photographs. Each case study will cover the requirement, challenge, solution, implementation and result."
          />
          <Reveal>
            <div className="rounded-xl border border-cts-line bg-cts-soft p-8 md:p-10" data-testid="projects-documenting-panel">
              <div className="flex items-center gap-3 mb-5">
                <span className="inline-flex items-center justify-center w-11 h-11 rounded-md bg-white border border-cts-line">
                  <FolderKanban size={20} strokeWidth={1.75} className="text-cts-red" />
                </span>
                <h2 className="h3-display">Project Areas We Expect to Document</h2>
              </div>
              <div className="flex flex-wrap gap-3">
                {CATEGORIES.map((cat) => (
                  <span key={cat.label} className="inline-flex items-center gap-2 rounded-md border border-cts-line bg-white px-4 py-2.5 font-heading font-bold text-[13px] uppercase tracking-wide text-cts-charcoal">
                    <cat.icon size={16} className="text-cts-red" /> {cat.label}
                  </span>
                ))}
              </div>
              <p className="text-[15px] text-cts-charcoal mt-6 leading-relaxed">
                Have a requirement like these? Talk to us — your project could be one of our first
                published case studies.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
      <CtaBand
        title="Have a Project in Mind?"
        text="Tell us about your requirement — networking, CCTV, computers or a complete setup."
        requirement="Business IT Requirements"
        waMsg={WA_MESSAGES.business}
        primaryLabel="DISCUSS YOUR PROJECT"
      />
    </>
  );
}
